import axios from '../axiosConfig'; // Assuming this is your configured Axios instance
import { API_BASE_URL } from '../config';
const baseURL = API_BASE_URL;
 
  const getInventoryList = async (data) => {
    var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
    if (! axios.defaults.headers.common["Authorization"]){
      headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
    }

    try { 
      const param = {
        page: data.page ? data.page : 1,
        per_page: data.per_page ? data.per_page : 10,
      };
      
      // Add search parameter if provided
      if (data.ilike && data.ilike.trim()) {
        param.ilike = data.ilike.trim();
      }
      
      console.log('Inventory API params:', param);
      
      const response = await axios.get('/inventory/items', {
        headers: headers,
        params: param
      });
      return response;
    } catch (error) {
      console.error('Error fetching inventory:', error);
      return error;
    }
  }
 

   
  export  {getInventoryList, baseURL};